
import { Component, Prop, Vue } from 'vue-property-decorator';
import CustomAlert from './Alert.vue';

@Component({ components: { CustomAlert } })
export default class GlobalAlert extends Vue {
  @Prop({ type: Boolean, default: false }) readonly dismissible!: boolean;

  @Prop({ type: String, required: true }) readonly text!: string;

  @Prop({ type: String, required: true }) readonly type!: string;

  @Prop({ type: Number, required: true }) readonly id!: number;

  @Prop({ type: Boolean, default: false }) readonly timed!: boolean;

  @Prop({ type: Number, default: 3000 }) readonly totalShowTime!: number;

  showTime = 0;

  interval: number | null = null;

  close() {
    this.$emit('close', this.id);
  }
}
